module.exports = __webpack_public_path__ + "3a571175434763d2a5eb0af0e20888e0.svg";